
<template>
  <div class="page-wrapper" id="page-wrapper" style="overflow-y: scroll; padding-bottom: 50px;">

    <div style="width: 100%; height: 60px; display: flex;">
      <div style="width: calc(100% - 50px); height: 50px;">
        <input v-model="searchWord" @keyup="searchProduct" style="border: 1px solid #ccc; height: 40px; line-height: 40px; padding-left: 10px; width: calc(100% - 30px); margin: 10px 15px;" placeholder="search product"/>
      </div>
      <div style="width: 50px; height: 50px;">
        <div style="width: 40px; height: 40px; line-height: 40px; text-align: center; margin: 10px 10px 0 0; border-radius: 20px; border: 1px solid red; background: #ffe4e4; color: white;" @click="clearSearch"><i class="fas fa-times"></i></div>
      </div>
    </div>

    <div style="width: 100%; height: calc(100% - 70px); background: #dedede; overflow-y: auto; padding-bottom: 50px;">
      <div class="container pt-0">
        <div class="row pt-0">
          <div class="col-12 pt-0">
            <template  v-for="p in products">
              <div class="wms-product-card" v-if="p.parentId === 0" :key="'product-item-' + p.id" @click="openProduct(p)">
                <div class="wms-product-card-category-title">
                  {{getCategoryTitle(p.categoryId)}}
                </div>
                <div class="wms-product-card-product-title">

                  {{p.title}}
                </div>

                <div v-if="p.parentId === 0" class="wms-product-card-details">
                  Stock: {{p.currentStock}}
                </div>

              </div>
            </template>

          </div>
        </div>
      </div>
    </div>
    <wms-product-view v-if="productView"
                      :product="productView.product"
                      :on-close="closeProduct"

    >

    </wms-product-view>
  </div>
</template>
<script>
import {millisToHHMM, showDialog} from "../api/utils";
import {getUserByToken} from "../api/user";
import {getWmsCategories, wmsSearchProducts} from "../api/wms";
import WmsProductView from "./WmsProductView.vue";
export default {
  name:'Warehouse',
  data() {
    return {
      user:false,
      searchWord:'',
      categories:[],
      products:[],
      productView: false,
    }
  },
  components: {
    WmsProductView,
  },
  created() {

  },
  mounted() {
    this.getMyInfo();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    timeString: millisToHHMM,
    getMyInfo: function() {
      let self = this;
      getUserByToken()
        .then(function(data) {
          self.$data.user = data;
          self.getCategories();
        })
        .catch(function(err) {

          console.log(err);

        })
    },
    getCategoryTitle: function(id) {
      for(let i = 0 ; i < this.$data.categories.length ; i++) {
        if(this.$data.categories[i].id === id) {
          return this.$data.categories[i].title;
        }
      }

      return 'Unknown category (' + id + ')';
    },
    getCategories: function() {
      let self = this;
      getWmsCategories()
        .then(function(data) {
          if(data.success === true) {
            self.$data.categories = data.item;
          } else {
            showDialog("Could not get category list");
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR at getting category list");
        })
    },
    clearSearch: function() {
      this.$data.searchWord = '';
      this.$data.products = [];
    },

    searchProduct: function() {
      if(this.$data.searchWord.length < 3) {
        this.$data.products = [];
        return;
      }

      let self = this;
      wmsSearchProducts(this.$data.searchWord)
        .then(function(data) {
          if(data.success === true) {
            self.$data.products = data.item;
          } else {
            self.$data.products = [];
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })

    },
    openProduct: function(product) {
      this.$data.productView = {
        product: product,
      }
    },
    closeProduct:function() {
      this.$data.productView = false;
    }
  }
}
</script>

<style scoped>
.wms-product-card {
  margin: 20px 5px;
  background: white;
  box-shadow: 3px 5px 5px rgba(0,0,0,0.3);
  border-radius: 10px;
}
.wms-product-card-category-title {
  border-bottom: 1px solid #aaa;
  line-height: 20px;
  font-size: 15px;
  padding: 5px 10px;
}
.wms-product-card-product-title {
  padding: 10px 10px;
  font-size: 18px;
  font-weight: bold;
}
.wms-product-card-details {
  border-top: 1px solid #ccc;
  padding: 5px 10px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Warehouse.vue